import * as CidadeOperations from './operations';
import CidadeReducer from './reducer';

export { CidadeOperations };

export default CidadeReducer;
